import {Button, Form, message} from "antd";
import {CustomInput} from "../../components/CustomForm";
import React, {useEffect, useRef, useState} from "react";
import styled from "styled-components";
import {useMutation, useQuery, useQueryClient} from "react-query";
import {
    changeEmail,
    getPersonalInfo,
    getVerificationCodeForEmailChange,
} from "../../api/User";
import {useTranslation} from "react-i18next";
import {userLogout} from "../../features/user/userSlice";
import {useDispatch} from "react-redux";
import {useNavigate} from "react-router-dom";

const Title = styled.h2`
  font-size: 32px;
  color: #fff;
`;

const Container = styled.div`
  width: 495px;
  min-height: calc(100vh - 184px);
  display: flex;
  flex-direction: column;
  justify-content: center;
`

const VerificationTips = styled.div`
  position: absolute;
  right: 35px;
  top: 0;
  line-height: 45px;
  cursor: pointer;
  z-index: 2;

  span {
    /* width: 120px; */
    color: #18eac4;
    font-size: 12px;
    line-height: 1.5;
    display: inline-block;
    /* padding-bottom: 1px; */
  }

  span:hover {
    border-bottom: 1px solid #18eac4;
  }

  .second-tips {
    color: #fff;
    font-size: 12px;
    line-height: 1.5;
    display: inline-block;
    width: 120px;
    text-align: center;
  }
`

const After = ({ setVerificationKey, form }) => {
    const [state, setState] = useState(61);
    const Timer = useRef(null);
    const {mutate: sendCodeMutate, data: sendCodeData} = useMutation(getVerificationCodeForEmailChange)

    const startTimer = () => {
        Timer.current = setInterval(() => {
            setState((prve) => prve - 1);
        }, 1000);
    };

    useEffect(() => {
        const {code, data} = sendCodeData ?? {}
        if (code === '10000' && data) {
            setVerificationKey(data.key);
            message.success('Verification code has been sent');
            setState((prve) => prve - 1);
            startTimer();
        }
    }, [sendCodeData])

    useEffect(() => {
        if (state <= 0 && Timer.current) {
            clearInterval(Timer.current);
            setState(61);
        }
    }, [state]);

    return (
        <VerificationTips>
            {state >= 61 || state === 0 ? (
                <span
                    onClick={() => sendCodeMutate(form.getFieldValue('email'))}
                >
          Send Verification Code
        </span>
            ) : (
                <div className="second-tips">{state}s</div>
            )}
        </VerificationTips>
    );
};

const CodeWrapper = styled.div`
  position: relative;
`

export const ChangeEmail = () => {
    const [verificationKey, setVerificationKey] = useState()
    const [hasPassword, setHasPassword] = useState(false)
    const { t } = useTranslation();
    const [form] = Form.useForm();
    const {mutate: emailChangeMutate, data: emailChangeData, isLoading: emailChangeLoading} = useMutation(changeEmail)
    const {data: userInfo} = useQuery('userinfo', getPersonalInfo)
    const dispatch = useDispatch();
    const queryClient = useQueryClient()
    const navigate = useNavigate();

    useEffect(() => {
        if (userInfo) {
            setHasPassword(!userInfo.data?.is_wallet_user)
        }
    }, [userInfo])

    useEffect(() => {
        if (emailChangeData && emailChangeData.code === '10000') {
            message.success('Your email has been successfully updated. Please login using your new email!', 5);
            setTimeout(() => {
                dispatch(userLogout());
                queryClient.removeQueries()
                navigate('/login');
            }, 1000)
        }
    }, [emailChangeData])

    const onFinish = (values) => {
        console.log(values, verificationKey)
        emailChangeMutate({
            ...values,
            verification_key: verificationKey,
        })
    }

    return (
        <Container>
            <Title>Change Email</Title>
            <Form
                form={form}
                onFinish={onFinish}
                autoComplete="off">
                <Form.Item
                    name="email"
                    rules={[
                        { required: true, message: 'Please input your email' },
                        { type: 'email', message: 'The input is not valid email' },
                    ]}
                >
                    <CustomInput
                        placeholder={'Please enter a new email'}
                    />
                </Form.Item>
                <Form.Item noStyle>
                    <CodeWrapper>
                        <Form.Item
                            name="verification_code"
                            hasFeedback
                            rules={[
                                { required: true, message: 'Please input Verification Code' },
                            ]}
                        >
                            <CustomInput
                                className={'verification-code-container'}
                                placeholder={t('CompanyRegisterPage.VerificationCode')}
                            />
                        </Form.Item>
                        <After setVerificationKey={setVerificationKey} form={form} />
                    </CodeWrapper>
                </Form.Item>
                {
                    hasPassword && (
                        <Form.Item
                            name="password"
                            rules={[
                                { required: true, message: 'Please input your password' },
                            ]}
                        >
                            <CustomInput
                                type='password'
                                placeholder='Please enter your current account password'
                            />
                        </Form.Item>
                    )
                }
                <Form.Item>
                    <Button
                        type="primary"
                        htmlType="submit"
                        loading={emailChangeLoading}
                        style={{
                            height: '42px',
                            backgroundColor: '#18EAC4',
                            borderColor: '#18EAC4',
                            color: '#000',
                            borderRadius: '4px',
                        }}
                    >
                        {t('user_center.setPassword.submit')}
                    </Button>
                </Form.Item>
            </Form>
        </Container>
    )
}